import { IDmKhoa } from "../../../model/respone/category/IDmKhoa";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmKhoaActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmKhoa[],
  LOAD_ERRR: "",
};
export const eDmKhoaActionIds = generateActionTypeIds(
  eDmKhoaActionsObj,
  "KHOA"
);
export type IDmKhoaActionTypes = IGenericActionType<
  typeof eDmKhoaActionsObj,
  "KHOA"
>;
